import { IReceiptData } from "./ApiCalls";
import { GlobalConstants } from "./GlobalConstants";
import { GlobalPermissions } from "./GlobalPermissions";
import { GlobalVariables } from "./GlobalVariables";
import { ReduxUpdater } from "./redux/ReduxUpdater";

export const FilterCategories = (receipt: IReceiptData, doFilter: boolean) => {
    const permissionString = `${receipt.message_id.startsWith('RCPT') ? 'R' : ''}${receipt.receipt_type === 'petty_cash' ? '$' : ''}${ReduxUpdater.authenticatedUser?.user_role}`;
    // console.log('CHECK:', permissionString);
    if (!GlobalPermissions.UX.EXPENSES.ReviewAndConfirm.LimitedCategories.includes(permissionString)) {
        return GlobalConstants.CreateReceiptCategories.filter(o => o.value !== '9');
    }
    
    const filtered = GlobalVariables.accountingCategoriesFiltered(receipt.user_description, doFilter);

    console.log('FilterCategories', doFilter, receipt.maris_category_id, filtered);

    if (filtered.map(o => o.value).includes((receipt.maris_category_id ?? -1).toString())) {
        return filtered;
    }

    return GlobalVariables.accountingCategoriesFiltered(null);
};